var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10186_70478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 5.83341C3.33398 5.39139 3.50958 4.96746 3.82214 4.6549C4.1347 4.34234 4.55862 4.16675 5.00065 4.16675H15.0007C15.4427 4.16675 15.8666 4.34234 16.1792 4.6549C16.4917 4.96746 16.6673 5.39139 16.6673 5.83341V15.8334C16.6673 16.2754 16.4917 16.6994 16.1792 17.0119C15.8666 17.3245 15.4427 17.5001 15.0007 17.5001H5.00065C4.55862 17.5001 4.1347 17.3245 3.82214 17.0119C3.50958 16.6994 3.33398 16.2754 3.33398 15.8334V5.83341Z",
    stroke: "#315146",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 2.5V5.83333",
    stroke: "#315146",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 2.5V5.83333",
    stroke: "#315146",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 9.16675H16.6673",
    stroke: "#315146",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10186_70478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgCalendar;